var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread-crumd"},[_c('Breadcrumb',_vm._l((_vm.list),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }